<div class="layout-wrapper p-input-filled" [ngClass]="{
        'layout-menu-overlay': applicationServiceExt.isSidebarOverlay,
        'layout-menu-slim': applicationServiceExt.isSidebarSlim,
        'layout-menu-static': applicationServiceExt.isSidebarStatic,
        'layout-menu-active': applicationServiceExt.isMenuActive,
        'layout-menu-mobile-active': applicationServiceExt.isMobileMenuActive,
        'layout-topbar-mobile-active': applicationServiceExt.isMobileTopbarActive,
        'layout-rightmenu-active': applicationServiceExt.isRightMenuActive
        }" [class]="'layout-menu-' + applicationServiceExt.themeMenu + ' layout-topbar-' + applicationServiceExt.themeTopbar">

    <a class="skip-link" href="#hauptinhalt">Zum Inhalt springen</a>

    <pin-it-track-web-app-topbar></pin-it-track-web-app-topbar>

    <!--<pit-early-bird-web-app-menu-right></pit-early-bird-web-app-menu-right>-->

    <div class="menu-wrapper" role="navigation" aria-label="Hauptmenü" (click)="applicationServiceExt.onMenuClick($event)">
        <div class="layout-menu-container">
            <pin-it-track-web-app-menu></pin-it-track-web-app-menu>
        </div>
    </div>

    <div class="layout-main">
        <pin-it-track-web-app-breadcrumb *ngIf="(isAppModeGuest === false)">
            <ng-content></ng-content>
        </pin-it-track-web-app-breadcrumb>

        <div id="hauptinhalt" class="layout-content" role="main" tabindex="-1">
            <h1 class="nur-fuer-screenreader">{{areaHeading}}</h1>
            <div class="container-app-main">
                <router-outlet></router-outlet>
            </div>
        </div>

        <!--<app-footer></app-footer>-->
    </div>

    <!--<app-config></app-config>-->

    <div *ngIf="applicationServiceExt.isMobileMenuActive" class="layout-mask modal-in"></div>

</div>
<!--<div *ngIf="(coreServicesAccessor.authenticationService.authenticationStatus !== 3)">
    <router-outlet></router-outlet>
</div>-->
<ngx-loading [show]="(isBusy$ | async)" [config]="{backdropBorderRadius: '3px', fullScreenBackdrop: true}"></ngx-loading>

<p-toast position="bottom-right" [baseZIndex]="5000"></p-toast>
<p-confirmDialog [baseZIndex]="10000" acceptButtonStyleClass="p-button-success" rejectButtonStyleClass="p-button-danger"></p-confirmDialog>
